import { InjectionToken } from '@angular/core';

import { GasPositioning } from '../../utils/gas-positioning/gas-positioning.namespace';
import { GasPositioningPopup } from './gas-dynamic-positioning-popup.namespace';

export const GAS_POSITIONING_CONFIG = new InjectionToken<GasPositioningPopup.Config<any>>('gasPositioningConfig', {
  providedIn: 'root',
  factory(): GasPositioningPopup.Config<any> {
    return DEFAULT_GAS_POSITIONING_CONFIG;
  },
});

export const DEFAULT_GAS_POSITIONING_CONFIG: GasPositioningPopup.Config<any> = {
  offset: 0,
  preferablePositions: [
    GasPositioning.Direction.Bottom,
    GasPositioning.Direction.BottomRight,
    GasPositioning.Direction.BottomLeft,
  ],
  alignType: 'auto',
  arrowWidth: 16,
  isCloseByClickOutside: true,
};
